import { ColorPicker } from "@npm_leadtech/qr-ui-components";
import { ColorPickerAdapterProps } from "./types";
import { useColorPickerAdapter } from "./hooks";

export function ColorPickerAdapter(props: ColorPickerAdapterProps) {
  const {
    name,
    defaultValue,
    value,
    errorMessage,
    disabled,
    onChange,
    rules,
    dataQA,
    ...restProps
  } = props;

  const { currentValue, finalErrorMessage, isDisabled, handleChange } = useColorPickerAdapter({
    name,
    defaultValue,
    value,
    errorMessage,
    disabled,
    onChange,
    rules,
  });

  return (
    <ColorPicker
      {...restProps}
      id={props.id || name}
      value={currentValue}
      defaultValue={defaultValue}
      onChange={handleChange}
      errorMessage={finalErrorMessage}
      disabled={isDisabled}
      dataQA={dataQA || `color-picker-${name}`}
      dataTestId={props.dataTestId || `color-picker-${name}`}
    />
  );
}
